import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import { rel } from '../../../../../../utils/rel';

/**
 * 定义 Logo 组件
 */
class Logo extends PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { url, logo, subLogo },
        } = this.props;

        return (
            <div className={styles.logoBox}>
                <div className={styles.logo}>
                    <a href={url} target="_blank" rel={rel}>
                        <img src={logo} />
                    </a>
                </div>
                {/* <div className={styles.sub_logo}>
                    <img src={subLogo} />
                </div> */}
            </div>
        );
    }
}

export default errorBoundary(Logo);
